<!--
To add a new kind of field to serve as source to a flex field, see https://community-dc.max.gov/x/E4u6mQ
-->
<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<!--
A lot of the code in this template was copied directly from drop-down-form-field.component.html and
multi-drop-down-form-field.component and then modified.
-->
<!-- Useful for debugging:
<div style="color:red">{{IsAutoComplete ? 'Auto Complete' : 'Manual'}}, {{IsSingleSelect ? 'Single' : 'Multi'}} Select</div>
-->

<ng-template #templateOutput>
  <!--
  When autocomplete is configured the autocomplete componnent is used to render the flex field itself
  NOTE: Multiple selection AND autocomplete are not yet supported
  -->
  @if (this.AutocompleteEnabled && !this.IsDesign) {
    <div>
      <app-autocomplete #autocompletecomponenent
        [title]="this.DropDownOptionsTitle"
        [formInstanceElement]="FormInstanceElement"
        [formInstance]="FormInstance"
        [selectedValuesByFormField]="SelectedValuesByFieldId"
        [formFieldId]="this.FormField.id"
        [selectableValues]="FormField.selectOptions"
        (selectedItems)="handleAutoCompleteSelectionChange($event)"
        (onBlur)="this.blurValidation()">
      </app-autocomplete>
    </div>
  } @else {
    <div>
      <!-- --------------------------- DESIGN MODE --------------------------------- -->
      @if (this.Mode === 'design') {
        <div class="flex-row-top-right">
          <div class="fill-remaining-space">
            @if (this.HasInstructions) {
              @if (this.DisplayName) {
                <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
                  <span style="color: #EF0000;">*</span>
                }</div>
              }
              <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            }
            <div>
              <mat-form-field appearance="outline" class="dropdown-mat-form-field" title="{{DefaultDropdownValueText}}">
                @if (this.ShowLabel && !HasInstructions) {
                  <mat-label class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                  }</mat-label>
                }
                <mat-select disabled [(ngModel)]="this.DefaultDropdownValue">
                  <mat-option [value]="-1">{{this.DefaultDropdownValueText}}</mat-option>
                  @for (hshOption of this.ConfiguredOptions; track hshOption) {
                    <mat-option [value]="hshOption.OptionId">
                      {{hshOption.OptionText}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
      <!-- --------------------------- PREVIEW/INSTANCE MODE --------------------------------- -->
      @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
        <div class="flex-row-top-right">
            <div class="fill-remaining-space">
                @if (this.FormGroup !== null) {
                <!-- If there are instructions, display label first, then instructions then field -->
                @if (this.HasInstructions) {
                @if (this.DisplayName) {
                <div class="field-label" id="flex-{{this.FormField.id}}">
                    {{this.DisplayName}} @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                    }
                </div>
                }
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                @if (IsMultiSelect) {
                <div class="field-label">The maximum number of selections that can be made: {{this.MaxSelections}}</div>
                }
                }
                <!-- Much of this code was pulled from the old drop down component -->
                <form [formGroup]="this.FormGroup">
                    <!---------------------------------- SINGLE SELECT --------------------------------->
                    <!-- this <div> is position:relative -->
                    <div class="select-option-copy-button-div">
                        @if (IsSingleSelect) {
                        @if (FieldIsInGrid) {
                        <div style="display: flex; width: 100%; gap: 10px;">
                            <div style="flex-grow: 1;">
                                <mat-select formControlName="flexible_single_selection_form"
                                            [panelClass]="'flex-panel'"
                                            placeholder="{{this.SelectOptions?.length > 1 ? DropdownPlaceHolderText : ''}}"
                                            aria-label="{{this.AriaLabel}}"
                                            [attr.aria-required]="this.FormField.required"
                                            [required]="this.FormField.required"
                                            [disabled]="this.ReadOnly"
                                            (blur)="this.handleValidationOnBlur()"
                                            (selectionChange)="handleSingleSelectChange($event)">
                                    @for (strSelectOption of this.SelectOptions; track strSelectOption) {
                                    <mat-option title="{{strSelectOption}}"
                                                [value]="strSelectOption">
                                        {{strSelectOption}}
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                            <div style="height: 20px;">
                                <span (click)="CopyToClipboard()" title="Copy to Clipboard" style="padding-left: 8px;">
                                    <mat-icon>content_copy</mat-icon>
                                </span>
                                @if(!FormField.readOnly){
                                <span (click)="ClearSelection()" title="Clear Selection" style="padding-left: 8px;">
                                    <mat-icon>playlist_remove</mat-icon>
                                </span>
                                }
                            </div>
                        </div>
                        }

                        @else {
                        <mat-form-field appearance="outline" [floatLabel]="'always'" class="dropdown-mat-form-field" subscriptSizing="dynamic">
                            <!-- If there are no instructions, display label integrated into the field -->
                            @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                            <mat-label id="flex-{{this.FormField.id}}"
                                       class="field-label">
                                {{this.DisplayName}} @if (this.FormField.required) {
                                <span style="color: #EF0000;">*</span>
                                }
                            </mat-label>
                            }
                            @if (this.SelectOptions == null) {
                            <div style="height:0px;">Loading Options...</div>
                            }
                            <mat-select formControlName="flexible_single_selection_form"
                                        placeholder="{{this.SelectOptions?.length > 1 ? DropdownPlaceHolderText : ''}}"
                                        aria-label="{{this.AriaLabel}}"
                                        [attr.aria-required]="this.FormField.required"
                                        [required]="this.FormField.required"
                                        [disabled]="this.ReadOnly"
                                        (blur)="this.handleValidationOnBlur()"
                                        (selectionChange)="handleSingleSelectChange($event)">
                                @for (strSelectOption of this.SelectOptions; track strSelectOption) {
                                <mat-option title="{{strSelectOption}}"
                                            [value]="strSelectOption">
                                    {{strSelectOption}}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                        }
                        <!-- div containing copy and clear buttons for single select flex field -->
                        <div class="flex-buttons show-on-hover">
                            <button mat-icon-button (click)="CopyToClipboard()" title="Copy to Clipboard">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            @if(!FormField.readOnly){
                            <button mat-icon-button (click)="ClearSelection()" title="Clear Selection">
                                <mat-icon>playlist_remove</mat-icon>
                            </button>
                            }
                        </div>
                    </div>
                </form>
                <!---------------------------------- MULTI SELECT --------------------------------->
                <!-- Much of this code was pulled from the old multi-select drop down component -->
                @if (IsMultiSelect && FieldIsInGrid) {
                <div style="display: flex; width: 100%; gap: 10px; background-color: #e6f2ff;">
                    <div>
                        <span (click)="openSelections()" class="multi-select-text">Select</span>
                        <button mat-icon-button
                                style="position: absolute; margin-top: -14px;"
                                aria-label="Open Selections"
                                (click)="openSelections()">
                        </button>
                        <mat-select #multiSelect
                                    class="flex-in-grid"
                                    [panelClass]="'flex-panel'"
                                    [formControl]="this.DropDownOptionsFormControl"
                                    multiple
                                    aria-label="{{this.AriaLabel}}"
                                    [attr.aria-required]="this.FormField.required"
                                    [required]="this.FormField.required"
                                    (selectionChange)="handleMultiSelectChange($event)"
                                    (blur)="this.handleValidationOnBlur()"
                                    (opened)="multiSelectOpened()"
                                    (closed)="multiSelectClosed()"
                                    [disableOptionCentering]="true"
                                    tabindex="0">
                            <mat-select-trigger><!-- keep this even though blank --></mat-select-trigger>
                            @for (strSelectOption of this.SelectOptions; track strSelectOption) {
                            <mat-option [disabled]="this.IsDesign || this.canDisableOption(strSelectOption)"
                                        [value]="strSelectOption">
                                {{strSelectOption}}
                            </mat-option>
                            }
                        </mat-select>
                    </div>
                    <div style="flex-grow: 1;"></div>
                    <div>
                        <span style="margin-left: 36px; margin-right: 10px;">
                            {{this.SelectedChips.length}} of {{this.SelectOptions.length}} selected
                        </span>
                    </div>

                </div>
                }
                @else
                {
                @if (IsMultiSelect && !IsAutoComplete) {
                <div class="select-option-copy-button-div">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" class="dropdown-mat-form-field full-width" subscriptSizing="dynamic">
                        @if (this.SelectOptions == null) {
                        <div>Loading...</div>
                        }
                        <!-- class="{{this.Mode =='design' ? 'design-mode-field-label' : 'field-label'}}" -->
                        @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                        <mat-label id="flex-{{this.FormField.id}}"
                                   class="field-label">
                            {{this.DisplayName}} @if (this.FormField.required) {
                            <span style="color: #EF0000;">*</span>
                            }
                        </mat-label>
                        }
                        <span>
                            @if (!this.SelectionsOpen && (this.Mode == 'instance' || this.Mode == 'preview')) {
                            <button mat-raised-button
                                    aria-label="Open Selections"
                                    class="select-close-button"
                                    color="primary"
                                    (click)="openSelections()">
                                Select
                            </button>
                            }
                            @if (this.SelectionsOpen && (this.Mode == 'instance' || this.Mode == 'preview')) {
                            <button mat-raised-button
                                    aria-label="Close Selections"
                                    class="select-close-button"
                                    color="primary"
                                    (click)="closeSelections()">
                                Close
                            </button>
                            }
                        </span>
                        @if ((this.Mode == 'instance' || this.Mode == 'preview') && this.SelectOptions) {
                        <span class="selection-count">
                            {{this.SelectedChips.length}} of {{this.SelectOptions.length}} selected
                        </span>
                        }
                        <mat-select #multiSelect
                                    [formControl]="this.DropDownOptionsFormControl"
                                    multiple
                                    aria-label="{{this.AriaLabel}}"
                                    [attr.aria-required]="this.FormField.required"
                                    [required]="this.FormField.required"
                                    (selectionChange)="handleMultiSelectChange($event)"
                                    (blur)="this.handleValidationOnBlur()"
                                    (opened)="multiSelectOpened()"
                                    (closed)="multiSelectClosed()"
                                    [disableOptionCentering]="true"
                                    tabindex="0"
                                    class="dropdown-select">
                            <mat-select-trigger><!-- keep this even though blank --></mat-select-trigger>
                            @for (strSelectOption of this.SelectOptions; track strSelectOption) {
                            <mat-option [disabled]="this.IsDesign || this.canDisableOption(strSelectOption)"
                                        [value]="strSelectOption">
                                {{strSelectOption}}
                            </mat-option>
                            }
                        </mat-select>
                        @if (SelectOptions) {
                        <mat-chip-listbox [formControl]="this.DropDownOptionsFormControl" chipListSelectable="true">
                            @for (selected of SelectedChips; track selected) {
                            <mat-chip-option [attr.aria-selected]="true"
                                             [ariaSelected]="true"
                                             [removable]="true"
                                             (removed)="onRemove(selected)"
                                             class="mat-elevation-z2">
                                {{selected}}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-option>
                            }
                            @if (this.ShowRemoveAll) {
                            <mat-chip-option class="mat-elevation-z3 remove-all-chip"
                                             (click)="this.removeAllChips()"
                                             (keyup.enter)="this.removeAllChips()">
                                Remove All
                            </mat-chip-option>
                            }
                        </mat-chip-listbox>
                        }
                    </mat-form-field>
                    <!-- div containing copy and clear buttons for multi-select flex field -->
                    <div class="flex-buttons show-on-hover">
                        <button mat-icon-button (click)="CopyToClipboard()" title="Copy to Clipboard">
                            <mat-icon>content_copy</mat-icon>
                        </button>

                        <button mat-icon-button (click)="ClearSelection()" title="Clear Selection">
                            <mat-icon>playlist_remove</mat-icon>
                        </button>
                    </div>
                </div>
                }
                }
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                }
            </div>
      <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
  }
  @if (ShowLeaveBlankMessage) {
    <div style="font-size:8pt;color:grey;margin-top:-20px">Leave blank to select all</div>
  }
</div>
}
<ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
</ng-template>

<!-- When autocomplete has NOT been selected ... -->

<!-- output the #templateOutput defined above -->
<div class="outer-div">
  <div class="flex-row-top-right">

    <div class="fill-remaining-space">
      <ng-template [ngTemplateOutlet]="templateOutput"></ng-template>
    </div>

    <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
  </div>
</div>
